
import img from '../assets/image/Banner3_2.png'

const data = [
    {
        "id": 1,
        "name": "Jewellery is the most transformative thing you can wear classy girls wear pearls.",
        "dec":"Embrace your individuality and radiate your passion; the community will acknowledge and reward you!",
        "img": img,
        "btn":"Buy Now",
        "position": "end-position" ,
        "speed":1
    }
];

export default data;